// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"A_TheComp___fVCi"};